import React, { useContext, useReducer } from 'react';
import reducer from './home-reducer';

const initialState = {
  //Shared state
};
const HomeContext = React.createContext();

const HomeProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <HomeContext.Provider value={{ ...state }}>{children}</HomeContext.Provider>
  );
};

const useHomeContext = () => {
  return useContext(HomeContext);
};

export { HomeProvider, useHomeContext };
